import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { UPDATE_COMMUNITY_MEMBER_ROLES_RESOURCE } from '../../constants';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_COMMUNITY_MEMBER_ROLES_RESOURCE,
      method: 'post',
      request: (tag, organisationId, body, callback, rejectCallback) => ({
        url: apiRoutes.communityMemberRoles(tag, organisationId),
        body,
        meta: {
          callback,
          rejectCallback,
        },
      }),
    },
  ])(ComposedComponent);
